/**
 * Set the number of results to show
 *
 * Will trigger new search
 *
 * @param resultsPerPage Integer
 */
export default function setResultsPerPage(resultsPerPage) {
  var _console;

  if (this.debug) // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, ["Search UI: Action", "setResultsPerPage"].concat(Array.prototype.slice.call(arguments)));

  this._updateSearchResults({
    current: 1,
    resultsPerPage: resultsPerPage
  });
}